module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAA+ElEQVR4AezUPQ4BURAH8HnrFloUqBRu4RwSTiBEhcQdXELhFgoVCrRuYZ83xSrYzXxFthmx2WQzM//fTnY3g5p/DvAN+AZ8A+YN9JePoeVbZgJ05/dFfOX73uw20CLUAAwPAdYQQhMyOGgRKsAnvLhtA0IM+Ak3IkSAynADgg0gw5UIFgBftQBxWmSQ5/RMxEaYkHWpgAU4r1pHyGEEMT5TD/mPALvrpj0mC1MBC5Dq4LLtnDgISTjOZQOwmEJIw3GmCIANVQhNOM4TA7DpG6ENx1kqADYWCEs4zlEDsBkR3Kcd68sOE6BsoPSaA3wDvoG/b4B6Ld8AAAD//99NeCkAAAAGSURBVAMA8k1kQeIFdHQAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/AboutUS/item1.png
// module id = Tzwf
// module chunks = 7